import intlTelInput from 'intl-tel-input';
import 'country-select-js';
import * as util from './util';

const BookingPersonalDetailsForm = function($root) {
    this.$root = $root;

    const $mobileInput = this.$root.find('input.mobile');

    this.telInputComponent = intlTelInput($mobileInput[0], {
        utilsScript: SooriyaConfig.baseUrl + 'assets/front/vendor/intl-utils.js',
        preferredCountries: $mobileInput.attr('data-preferredcountries').split(','),
        separateDialCode: true
    });

    $root.find("#agree").change(function() {
        if (this.checked) {
            $('#Continue').prop("disabled", false);
            $('#Continue').removeClass('button-type-3');
            $('#Continue').addClass('button-type-2');
        } else {
            $('#Continue').prop("disabled", true);
            $('#Continue').removeClass('button-type-2');
            $('#Continue').addClass('button-type-3');
        }
    });

    const $countryInput = $root.find('#country');
    let options = {};

    $countryInput.on('change', function(e) {
        var countryData = $(this).countrySelect("getSelectedCountryData");
        $root.find('.country-iso').val(countryData.iso2);
    });

    options.defaultCountry = $countryInput.attr('data-defaultcountry');
    if (typeof $countryInput.attr('data-preferredcountries') != 'undefined') {
        options.preferredCountries = $countryInput.attr('data-preferredcountries').split(',');
    }
    options.responsiveDropdown = true;

    $root.find('#country').countrySelect(options);

    this.initContinueButton();
}
	
BookingPersonalDetailsForm.prototype.initContinueButton = function() {
    const _this = this;
    const $submitBtn = this.$root.find('.btn-continue');

	$submitBtn.on('click', function(e) {
		const data = JSON.parse($('.booking_request_data').val());

		let grooms = [];

		$.each(data.rooms, function(index, item) {
			grooms.push({
				item_id: item.roomId,
				item_name: item.name,
				item_category: 'Accommodation',
				price: item.price,
				index: index
			});
		});

		dataLayer.push({
			"ecommerce": null,
			"event": 'add_payment_info',
			"ecommerce": {
				"currency": data.currency,
				"value": data.totals.total,
				"payment_type": "Credit Card",
				"items": grooms
			}
		});
	});

    _this.$root.on('submit', function(e) {
        e.preventDefault();

        let formData = _this.$root.serialize();
        formData += '&mobileCountryCode=' + _this.telInputComponent.getSelectedCountryData().dialCode;

        jQuery.ajax({
            url: _this.$root.attr('data-ajax-url'),
            data: formData,
            type: "POST",
            success: function(response) {
                const data = response.data;
                
                var form = document.createElement("form");
                form.setAttribute("method", "POST");
                form.setAttribute("name", "booknow");
                form.setAttribute("action", data.cybersource.url);

                for (let key in data.cybersource.params) {
                    let value = data.cybersource.params[key];
                    let hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", value);
                    form.appendChild(hiddenField);
                }

                document.body.appendChild(form);
                form.submit();
            },
            error: function(data) {
                $("#mytext").html('Unknown error. Please try again later or contact via info@sooriya.com (Error #: 102)');
                $("#myModal").modal('show');
            }
        });
    });
};

export default BookingPersonalDetailsForm;